import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_BE_UQ || "uq.be.styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_BE_UQ || "uqbe-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_BE_UQ || 24227,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_BE_UQ || 24228,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_BE_UQ ||
    "1:160978693362:web:a50de507765d637547346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-BVR80HWHLR" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: false,
  showDualPrice: true,
  languages: [LANGUAGE.FR, LANGUAGE.NL, LANGUAGE.EN],
  countryRegion: "Europe/Brussels",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    },
    [LANGUAGE.NL]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    },
    [LANGUAGE.FR]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2,
        "UTC+1": 1,
        "UTC+2": 2
      }
    }
  },
  timeZoneParentCategory: {
    "UTC+1": "CET",
    "UTC+2": "CEST"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.NL]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.FR]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>",
    [LANGUAGE.NL]: "<dd>/<mm>",
    [LANGUAGE.FR]: "<dd>/<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: true
};

export default _countryEnv;
